/**
 * Extracts a short display label (first name) from a participant string
 * for use in collapsed participant lists (e.g. "Pietro, Jane").
 *
 * - "Jane Kariuki <Jane.Kariuki@...>" → "Jane"
 * - "pietro.villani@jamboofresh.com" → "Pietro"
 */
export function participantToFirstName(participant: string): string {
    const s = participant.trim();
    if (!s) return "";

    // Format "Display Name <email>": use part before "<", take first word
    const angleIdx = s.indexOf("<");
    if (angleIdx !== -1) {
        const displayName = s.slice(0, angleIdx).trim();
        const firstWord = displayName.split(/\s+/)[0] ?? "";
        return capitalizeFirst(firstWord);
    }

    // Plain email: local part (before @), then first segment if contains "."
    const atIdx = s.indexOf("@");
    const local = atIdx !== -1 ? s.slice(0, atIdx) : s;
    const segment = local.includes(".") ? local.split(".")[0] ?? local : local;
    return capitalizeFirst(segment);
}

function capitalizeFirst(str: string): string {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
